<template>
    <v-card :height="heightImage">
        <v-card-title class="text-no-wrap ma-1 mb-0 pb-0 mt-0" >
            <!-- pl-0: jmeno/HP bar zarovnane na stejny levy inset (20px) jako
                 typova pilulka/badges a Skilly tlacitko - zadani uzivatele
                 2026-09-02 ("hp bar a name maji jine odsazeni nez badges"). -->
            <v-container max-width="40%" class="black--text pr-0 pl-0" style="z-index: 9;">
                <v-row v-if="pokemon.evolveProgress !== undefined && pokemon.evolveProgress !== null" class="pa-0 ma-0">
                    <PokemonProgressBar :percent="pokemon.evolveProgress" variant="evolve" :height="3"/>
                </v-row>
                <v-row class="pa-0 ma-0">
                    <div class="pa-1" style="background-color: rgba(255,255,255,0.63); border-radius: 5px;">
                        <span style="position:relative; top: 5px; z-index: 0;">{{getPokemonName()}}</span>
                    </div>
                    <v-progress-linear
                        background-color="bar-hp-red"
                        color="bar-hp-green"
                        height="12"
                        rounded
                        style="position: relative; top: -40px; z-index: 1;"
                        class="caption pa-0 ma-0"
                        min-width="100"
                        :value="getHp()"
                    >
                        <div :style="`box-shadow: 0 0 8px 12px ${$vuetify.theme.dark ? 'rgba(0,0,0,0.43)' : 'rgba(255,255,255,0.43)'}; background-color: ${$vuetify.theme.dark ? 'rgba(0,0,0,0.43)' : 'rgba(255,255,255,0.43)'}; border-radius: 40%; position:relative; top: 0px; z-index: 10;`">
                            <strong class="pm-hp-text"> {{ pokemon.hp }}/{{ pokemon.maxHp }}</strong>
                        </div>
                    </v-progress-linear>
                </v-row>
                <v-row v-if="pokemon.levelProgress !== undefined && pokemon.levelProgress !== null" class="pa-0 ma-0" style="position: relative; top: -40px;">
                    <PokemonProgressBar :percent="pokemon.levelProgress" variant="level" :height="3"/>
                </v-row>
            </v-container>
            <v-spacer/>
        </v-card-title>
        <PokemonCardBadges
            :pokemon="pokemon"
            :items="items"
            :show-item-button="!inFight"
            :show-oak-toggle="inOak === true"
            :oak-state="oak"
            :oak-loading="isLoading || newDayLoading"
            :disable-oak-toggle="isFullPool && !oak"
            :in-fight="inFight"
            :dialog-stones="dialogStones"
            style="--pcb-top: 80px; --pcb-inset: 20px;"
            @toggle-oak="toggleOak"
            @item-used="onItemUsed"
            @item-use-error="$emit('item-use-error', $event)"
            @evolve="evolvePokemon"
        />
        <div class="pokemon-manager-dismiss-wrap" :class="{'pokemon-manager-dismiss-wrap--mirrored': rightHanded}">
            <v-btn
                v-if="leave === true"
                rounded
                class="skin-btn-dismiss"
                small
                :disabled="inFight"
                :loading="isLoading || newDayLoading"
                @click="leavePokemon"
            >{{ $t('pokemon.pokemonManager.dismissButton') }}</v-btn>
        </div>

        <v-card-text>
            <div style="height:100%;">
                <v-img
                    class="self-center"
                    :src="getIcon()"
                    contain
                    style="position: absolute; top: 0px; left:0px;"
                    :height="heightImage"
                />

            </div>
        </v-card-text>
        <v-card-actions class="align-end">
            <PokemonLevelBadge
                v-if="pokemon.pokemonExperience"
                :level="pokemon.level"
                :free-exp="pokemon.pokemonExperience.freeExp"
                :exp-title="$t('pokemon.pokemonManager.statsExpTooltip') + ': ' + pokemon.pokemonExperience.exp + ' / ' + pokemon.pokemonExperience.freeExp"
                style="--plb-level-inset: 14px; --plb-level-bottom: 16px; --plb-exp-inset: 100px; --plb-exp-bottom: 24px;"
            />
            <!-- Hvezdicka "muze se naucit novy skill" prekryva horni roh
                 tlacitka (soucast tlacitka, ne samostatny prvek vedle) -
                 stejny vzor jako .pokemon-detail-skills-star v
                 PokemonDetail.vue, zadani uzivatele 2026-09-02. -->
            <div class="pokemon-manager-skills-wrap" :class="{'pokemon-manager-skills-wrap--mirrored': rightHanded}">
                <v-btn
                    :loading="isLoading || newDayLoading"
                    rounded
                    small
                    class="skin-btn-skills"
                    :title="pokemon.posibleBuySkill ? $t('pokemon.pokemonManager.canBuySkillTooltip') : undefined"
                    @click="toggleSkillsTable"
                >{{ $t('pokemon.common.skillsButton') }}</v-btn>
                <!-- pointer-events:none (at neblokuje klik na tlacitko pod
                     sebou), title proto nese samotne tlacitko vyse. -->
                <v-icon
                    v-if="pokemon.posibleBuySkill"
                    size="18"
                    class="pokemon-manager-skills-star"
                >mdi-star</v-icon>
            </div>
        </v-card-actions>

        <!-- SKILL DIALOG -->
        <v-row  v-if="pokemon && pokemon.pokemonType" justify="center">
            <ResponsiveDialog
                v-model="showSkills"
                :max-width="990"
                header-class="skin-window-header--pokemonskills"
                :header-title="$t('pokemon.pokemonManager.skillsDialogTitle', {name: pokemon.pokemonType.name, cost: pokemon.pokemonType.totalSkillCost})"
                card-class="skin-card"
            >
                <v-card-text class="justify-center pokemon-skills-scroll skin-window--pokemonskills">
                    <SkillDialogHeader
                        :img="getIcon()"
                        :img-alt="pokemon.name || pokemon.pokemonType.name"
                        :level="pokemon.level"
                        :free-exp="pokemon.pokemonExperience ? pokemon.pokemonExperience.freeExp : null"
                        :exp="pokemon.pokemonExperience ? pokemon.pokemonExperience.exp : null"
                    />

                    <!-- V boji jen read-only vypis (mode=view) misto nakupu -
                         stejne pravidlo jako mel PokemonDetail pres
                         allowBuySkills (=!isFightMode) v Team Board popupu. -->
                    <SkillListTable
                        :mode="inFight ? 'view' : 'buy'"
                        :items="pokemon.pokemonType.skills"
                        :pokemon="inFight ? null : pokemon"
                        :loading="isLoading"
                        @buy="buyNewSkill"
                        @open-detail="openSkillDetail"
                    />
                    <p v-if="pokemon && pokemon.pokemonType.isDitto">
                        {{ $t('pokemon.common.dittoNoSkills') }}
                    </p>
                </v-card-text>
                <SkillDetailPopup v-model="skillDetailOpen" :skill="selectedSkill"/>
            </ResponsiveDialog>

<!-- DIALOG EEVEE EVOLVE -->
            <ResponsiveDialog
                v-model="showEeveeStones"
                :max-width="800"
                :full-height="false"
                :header-title="$t('pokemon.common.eeveeDialogTitle', {name: pokemon.name})"
                header-class="skin-window-header--oak"
                card-class="skin-card"
            >
                <div class="skin-window--oak eevee-stones-bg">
                    <div class="eevee-stones-content">
                        <v-img
                            v-if="evolveEvveePokemon"
                            :src="evolveImg(evolveEvveePokemon.img)"
                            :alt="evolveEvveePokemon.name"
                            height="150"
                            contain
                            class="eevee-stones-pokemon-img"
                        />
                        <div v-if="dialogStones && dialogStones.length > 0" class="eevee-stones-grid">
                            <v-tooltip
                                v-for="stone in dialogStones"
                                :key="stone.id"
                                bottom
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <div
                                        class="eevee-stone-tile"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="evolveEevee(stone.id, evolveEvveePokemon.number)"
                                    >
                                        <v-img
                                            :src="require(`@/assets/pic${stone.picture}`)"
                                            class="eevee-stone-tile-img"
                                            contain
                                        />
                                        <div class="eevee-stone-tile-label">{{ $t('pokemon.common.eeveeStonePower', {value: stone.stoneVal}) }}</div>
                                    </div>
                                </template>
                                <div style="max-width: 100px;">
                                    {{ $t('pokemon.common.eeveeStoneTooltip', {name: pokemon.name, stoneName: stone.name, value: stone.stoneVal}) }}
                                </div>
                            </v-tooltip>
                        </div>
                        <v-card-title v-else-if="evolveEvveePokemon" class="justify-center">{{ $t('pokemon.common.eeveeNoStone', {type: evolveEvveePokemon.type}) }}</v-card-title>
                    </div>
                </div>
            </ResponsiveDialog>
        </v-row>
        <ConfirmDialog ref="confirmDialog"/>
    </v-card>
</template>



<script>
    import {mapActions, mapGetters} from 'vuex';
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import ConfirmDialog from "@/components/utils/ConfirmDialog";
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";
    import SkillListTable from "@/components/pokedex/SkillListTable";
    import SkillDetailPopup from "@/components/pokedex/SkillDetailPopup";
    import PokemonProgressBar from '@/components/pokemon/PokemonProgressBar';
    import SkillDialogHeader from '@/components/pokemon/SkillDialogHeader';
    import PokemonCardBadges from '@/components/pokemon/PokemonCardBadges';
    import PokemonLevelBadge from '@/components/pokemon/PokemonLevelBadge';
    import {pokemonImageSrc} from '@/utils/pokemonImage';
    import {flags} from '@/config/featureFlags';

    export default {
        components: {ConfirmDialog, ResponsiveDialog, SkillListTable, SkillDetailPopup, PokemonProgressBar, SkillDialogHeader, PokemonCardBadges, PokemonLevelBadge},
        props: {
            pokemonId: {type: Number, default: null},
            pokemonSource: {type: Object, default: null},
            switchProfOak: {type: Function, undefined},
            buySkill: {type: Function, default: function(){}},
            isFullPool: {type: Boolean, default: false},
            inOak: {type: Boolean, default: false},
            inFight: {type: Boolean, default: false},
            showStatsTable: {type: Boolean, default: true},
            leave: {type: Boolean, default: true},
            heightImage: {type: Number, default: 360},
            deletePokemonCallback: {type: Function, default: function(){}},
            updatePokemon: {type: Function, default: function(){}},
            updater: {type: Number, default: 0},
            stones: {type: Array, default: () => []},
            items: {type: Array, default: () => []},
        },
        data() {
            return {
                statistics: [],
                exp: null,
                oak: null,
                pokemon: {type: Object, default: null},
                show: false,
                stats: true,
                showStats: true,
                showSkills: false,
                showEeveeStones: false,
                evolveEvveePokemon: false,
                dialogStones: [],
                skillDetailOpen: false,
                selectedSkill: null,
                isLoading: true,
            }
        },
        computed: {
            ...mapGetters({
                position: 'journey/position',
                newDayLoading: 'journey/isLoading',
            }),
            rightHanded() {
                return flags.rightHanded;
            },
        },
        watch: {
            pokemonId() {
                this.isLoading = true;
                this.loadById();
            },
            pokemon() {
                if(this.pokemon){
                    this.oak = !this.pokemon.inProfesorOak;
                    this.statistics = [
                        { name:'HP', statName: 'hp', base: this.pokemon.pokemonType.baseHp, stats: this.pokemon.statsPoints.hp},
                    ];
                    this.exp = { name:'Exp', base: this.pokemon.pokemonExperience.exp, stats: this.pokemon.pokemonExperience.freeExp};
                }
            },
            updater() {
                this.loadById();
            },
            pokemonSource() {
                if(this.pokemonSource !== null){
                    this.pokemon = this.pokemonSource;
                }
            },
            position() {
                this.loadById();
            },
        },
        created() {
            this.showStats = this.showStatsTable;
            if(this.pokemonId !== null){
                this.loadById();
            }
            if(this.pokemonSource !== null){
                this.pokemon = this.pokemonSource;
                this.show = true;
                this.isLoading = false;
            }
        },
        methods: {
            ...mapActions({
                fetchPokemon: 'pokemon/fetchObject',
                evolveEeveeAction: 'trainer/evolveEevee',
                trainerInfoMessages: 'trainer/loadInfoMessages',
                refreshPosition: 'journey/loadPosition',
            }),
            toggleOak() {
                this.oak = !this.oak;
                this.switchProfOak(this.pokemon.id, this.oak);
            },
            getPokemonName() {
                if(this.pokemon){
                  if (this.pokemon.name) {
                      return this.pokemon.name;
                  }
                  if (this.pokemon.pokemonType) {
                      return this.pokemon.pokemonType.name;
                  }
                }
                return '???';
            },
            // !lockedInTradeOffer - stejny filtr jako PokemonDetail.vue::getTypeStones(), chybel tady
            // (bug 2026-09-01) - nabizel k evoluci i kameny zamcene v aktivni trade nabidce.
            getTypeStones(type) {
                return this.stones.filter(item => item.type.id === type && !item.lockedInTradeOffer);
            },
            getIcon(){
                if (this.pokemon.pokemonType){
                    return pokemonImageSrc(this.pokemon.pokemonType.img);
                }
                return '';
            },
            // bere cestu primo, ne pres getIcon() - evolve/evolveEvveePokemon nemaji vzdy plny pokemonType (viz PokemonType::getEvolveBase())
            evolveImg(img){
                return pokemonImageSrc(img);
            },
            getHp(){
                return parseInt(this.pokemon.hp) / parseInt(this.pokemon.maxHp) * 100;
            },
            toggleStats(){
                this.showStats = !this.showStats;
            },
            toggleSkillsTable(){
                this.showSkills = !this.showSkills;
            },
            openSkillDetail(skill) {
                this.selectedSkill = skill;
                this.skillDetailOpen = true;
            },
            buyNewSkill(skill){
                this.isLoading = true;
                const url = new URL("api/pokemon-buy-skill", API_ENTRYPOINT);
                let obj = {url: url, method: 'POST', obj: {pokemonId: this.pokemon.id, skillId: skill}};
                this.fetchPokemon(obj).then(
                    (data) =>{
                        this.pokemon = data;
                        this.isLoading = false;
                        this.buySkill(this.pokemon);
                    }
                ).catch(() => { this.isLoading = false; });
            },
            loadById() {
                if(this.pokemonId){
                    const url = new URL("api/pokemon-manager/{id}".replace('{id}',this.pokemonId), API_ENTRYPOINT);
                    let obj = {url: url, method: 'GET'};
                    this.fetchPokemon(obj).then(
                        (data) => {
                            this.pokemon = data;
                            this.isLoading = false;
                        }
                    ).catch(() => { this.isLoading = false; });
                }
            },
            async leavePokemon(){
                // noAutoConfirm - vyjmuto z globalniho auto-confirm prepinace (Options.vue), nevratna akce
                let rlyDelete = await this.$refs.confirmDialog.open(
                    this.$t('pokemon.pokemonManager.leaveConfirm'),
                    {
                        oak: true,
                        noAutoConfirm: true,
                    }
                );
                if (rlyDelete){
                    this.isLoading = true;
                    const url = new URL("api/leave-pokemon", API_ENTRYPOINT);
                    let obj = {url: url, method: 'POST', obj: {pokemonId: this.pokemon.id}};
                    this.fetchPokemon(obj).then(
                        () =>{
                            this.deletePokemonCallback(this.pokemon.id);
                        }
                    ).catch(() => { this.isLoading = false; });
                }
            },
            // useItem sam vraci jen trenerova data (ne pokemona v tomhle
            // tvaru), proto refetch pres loadById() misto pokusu o shallow
            // patch - stejny duvod jako u onPokemonUpdated v PokemonSwiper.vue.
            onItemUsed(){
                this.loadById();
                this.updatePokemon();
            },
            evolvePokemon(evolve){
                if (this.pokemon.pokemonType.number === 133 || this.pokemon.pokemonType.number === 1052|| this.pokemon.pokemonType.number === 1098) {
                    this.dialogStones = this.getTypeStones(evolve.type);
                    this.evolveEvveePokemon = evolve;
                    this.showEeveeStones = true;
                } else {
                    this.sendEvolvePokemon(evolve.id);
                }
            },
            async sendEvolvePokemon(id){
                let rlyEvolve = await this.$refs.confirmDialog.open(this.$t('pokemon.common.confirmEvolve', {name: this.pokemon.name}), {important: true});
                if (rlyEvolve){
                    this.isLoading = true;
                    const url = new URL("api/evolve-pokemon", API_ENTRYPOINT);
                    let obj = {url: url, method: 'POST', obj: {pokemonId: this.pokemon.id, evolveTypeId: id}};
                    this.fetchPokemon(obj).then(
                        (data) =>{
                            this.pokemon = data;
                            this.updatePokemon(data);
                            this.isLoading = false;
                            this.show = true;
                            this.trainerInfoMessages();
                            if (this.position && this.position.id) {
                                this.refreshPosition(this.position.id);
                            }
                        }
                    ).catch(() => { this.isLoading = false; });
                }
            },
            async evolveEevee(id,evolveId){
                let rlyEvolve = await this.$refs.confirmDialog.open(this.$t('pokemon.common.confirmEvolve', {name: this.pokemon.name}), {important: true});
                if (rlyEvolve){
                    this.isLoading = true;
                    let obj ={pokemonId: this.pokemon.id, stoneId: id, evolveId: evolveId};
                    this.evolveEeveeAction(obj).then(
                        (data) =>{
                            this.pokemon = data['pokemon'];
                            this.updatePokemon(data);
                            this.showEeveeStones = false;
                            this.isLoading = false;
                            this.trainerInfoMessages();
                            if (this.position && this.position.id) {
                                this.refreshPosition(this.position.id);
                            }
                        }
                    );
                }
            },
        },
    }
</script>

<style scoped>
/* Zadani uzivatele 2026-08-27 - cislo se v HP baru tesne nevejde cele,
   zmenseno o 1px oproti zdedenemu Vuetify .caption (12px). */
.pm-hp-text {
    font-size: 11px;
}
/* min-height:0 nutne pro scroll uvnitr ResponsiveDialog karty, stejny duvod jako .pokemon-skills-scroll nize */
.eevee-stones-bg {
    display: flex;
    flex-direction: column;
    min-height: 0;
}
.pokemon-skills-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    /* !important - Vuetify ".v-dialog > .v-card > .v-card__text" ma vyssi specificitu, jinak by prebilo padding-bottom */
    padding-bottom: var(--responsive-dialog-close-clearance) !important;
    position: relative;
}

.eevee-stones-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 16px var(--responsive-dialog-close-clearance) 16px !important;
}
.eevee-stones-pokemon-img {
    margin: 0 auto 12px;
}
.eevee-stones-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    gap: 12px;
    justify-items: center;
}
.eevee-stone-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    padding: 8px;
    border-radius: 10px;
    transition: background-color .15s ease;
}
.eevee-stone-tile:hover,
.eevee-stone-tile:active {
    background-color: rgba(0, 0, 0, 0.08);
}
.eevee-stone-tile-img {
    width: 70px;
    height: 70px;
}
.eevee-stone-tile-label {
    font-size: 13px;
    font-weight: 600;
    margin-top: 4px;
    text-align: center;
}
.pokemon-manager-dismiss-wrap {
    position: absolute;
    top: 62px;
    right: 32px;
    z-index: 9;
}
.pokemon-manager-dismiss-wrap--mirrored {
    right: auto;
    left: 32px;
}
.pokemon-manager-skills-wrap {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 9;
}
.pokemon-manager-skills-wrap--mirrored {
    left: auto;
    right: 20px;
}
/* Hvezdicka sedi na hornim rohu tlacitka (vetsina plochy NA tlacitku,
   kousek precniva) - "badge na rohu", ne samostatny prvek vedle tlacitka.
   !important na position/color nutne - Vuetify .v-icon ma vlastni
   position:relative a color, ktere by scoped tridu prebily (stejny pripad
   jako .pokemon-level-badge__star v PokemonLevelBadge.vue). */
.pokemon-manager-skills-star {
    position: absolute !important;
    top: 0;
    right: 0;
    transform: translate(25%, -35%);
    z-index: 1;
    pointer-events: none;
    color: #FFD700 !important;
    filter: drop-shadow(0 0 3px rgba(0,0,0,0.9)) drop-shadow(0 0 3px rgba(0,0,0,0.9));
}
.pokemon-manager-skills-wrap--mirrored .pokemon-manager-skills-star {
    right: auto;
    left: 0;
    transform: translate(-25%, -35%);
}
</style>
